import type { InputRef } from "antd";
import { useEffect, useRef } from "react";

/** Delay so focus runs after the popover overlay is visible and focus-trap is ready. */
const POPOVER_FOCUS_DELAY_MS = 150;

export function usePopoverInputFocus(enabled = true) {
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (!enabled) return;

    const timeoutId = window.setTimeout(() => {
      requestAnimationFrame(() => {
        inputRef.current?.focus({ preventScroll: true });
        inputRef.current?.input?.select?.();
      });
    }, POPOVER_FOCUS_DELAY_MS);

    return () => window.clearTimeout(timeoutId);
  }, [enabled]);

  return inputRef;
}

export function usePopoverInputNumberFocus(enabled = true) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!enabled) return;

    const timeoutId = window.setTimeout(() => {
      requestAnimationFrame(() => {
        const input = containerRef.current?.querySelector<HTMLInputElement>(
          ".ant-input-number-input"
        );
        input?.focus({ preventScroll: true });
        input?.select?.();
      });
    }, POPOVER_FOCUS_DELAY_MS);

    return () => window.clearTimeout(timeoutId);
  }, [enabled]);

  return containerRef;
}
